import * as React from 'react';
import axios from 'axios';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../hooks/useAuth";

import { jwtDecode } from "jwt-decode";

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.coolingpackages.com/">
        Richardson Cooling Packages LLC
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function Login() {
  const [loginFailedStatus, setLoginFailedStatus] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    axios.post('/api/login',
        {
          email: data.get('email'),
          password: data.get('password'),
        }).then(function (response) {
          // console.log(response);
          if (response.status === 200) {
              setLoginFailedStatus(false);
              const decoded = jwtDecode(response.data.token);
              // console.log(decoded);
              const userInfo = decoded.id;
              login({
                  token: response.data.token,
              });
              // console.log(userInfo[0]);
              // console.log(userInfo[1]);
              // console.log(response.data.token);
              // navigate('/dashboard');
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
              setLoginFailedStatus(true);
          }
        });
// console.log({
    //   email: data.get('email'),
    //   password: data.get('password'),
    // });
  };

  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h2>RCP RGA Portal</h2>
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              error={loginFailedStatus}
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              error={loginFailedStatus}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link variant="body2" onClick={() => navigate('/request_password_reset')}>
                  Forgot password?
                </Link>
              </Grid>
              {/*<Grid item>*/}
              {/*  <Link variant="body2" onClick={() => navigate('/register')}>*/}
              {/*    {"Don't have an account? Sign Up"}*/}
              {/*  </Link>*/}
              {/*</Grid>*/}
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
  );
}
